import { JSX } from "react";
import { Navigate } from "react-router-dom";
import { AppRouter } from "../../utils/enums/AppRouter";
import { AuthorizationStatus } from "../../utils/enums/AuthorizationStatus";

interface ConstructorPrivateRouteProps {
  authorizationStatus: AuthorizationStatus;
  children: JSX.Element;
}

export const ConstructorPagePrivateRoute = ({
  authorizationStatus,
  children,
}: ConstructorPrivateRouteProps) => {
  return authorizationStatus === AuthorizationStatus.Auth ? (
    children
  ) : (
    <Navigate to={AppRouter.Login} />
  );
};
